import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetTags } from 'hooks/useGetTags';
import { useLessonFormValidator } from 'hooks/useLessonFormValidator';
import { useNodeEditorValidator } from 'hooks/useNodeEditorValidator';
import { LessonForm } from 'components/views/editor/models/LessonForm';
import { createEmptyLessonForm } from "components/views/editor/helpers/lessonFormHelper";
import { GameEditorData } from 'components/views/editor/gameEditor/models/GameEditorData';
import { LessonType } from 'models/LessonType';

const emptyGameEditorData: GameEditorData = {
    fileId: null,
    launchParams: "",
    events: [],
};

export const useTrainingPageData = () => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language || 'en';

    const [lessonFormData, setLessonFormData] = useState<LessonForm | null>(null);
    const [editor, setEditor] = useState<any>(null);
    const [gameEditorData, setGameEditorData] = useState<GameEditorData>(emptyGameEditorData);

    const { tags, isLoading: tagsLoading } = useGetTags();
    const { isValid: isLessonFormValid, reset: resetFormErrors, errors: formValidationErrors } = useLessonFormValidator();
    const { isValid: isNodeEditorValid } = useNodeEditorValidator();

    const initializeEmptyForm = () => {
        setLessonFormData(createEmptyLessonForm(currentLanguage, LessonType.VR));
        setGameEditorData(emptyGameEditorData);
    };

    return {
        lessonFormData,
        setLessonFormData,
        editor,
        setEditor,
        gameEditorData,
        setGameEditorData,
        tags,
        tagsLoading,
        currentLanguage,
        isLessonFormValid,
        isNodeEditorValid,
        resetFormErrors,
        formValidationErrors,
        initializeEmptyForm
    };
};